import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import LotteryItem from '../lottery-item';

function LotteryList({ lotteries }) {
  const lotteryItems = lotteries.map((lottery, index) => (
    <LotteryItem key={index} lottery={lottery} />
  ));

  return <div className="lottery-list">{lotteryItems}</div>;
}

LotteryList.propTypes = {
  lotteries: PropTypes.instanceOf(List).isRequired,
};

export default LotteryList;



// WEBPACK FOOTER //
// ./src/views/components/lottery-list/index.js